<script setup lang="ts">
import background from '~/assets/images/backgrounds/auth.jpg';

const route = useRoute();
const { t } = useI18n();
const authorized = useCookie('authorized');

if (authorized.value)
  await navigateTo(<string>route.query.authRedirect || '/', {
    redirectCode: 302,
  });
</script>

<template>
  <main class="pt-header flex flex-1 items-center relative">
    <NuxtImg
      class="page-image-preview"
      :src="background"
      width="2703"
      height="2356"
      sizes="md:100vw lg:100vw xl:100vw xxl:100vw"
      format="avif"
      :alt="t('preview_alt')"
    />
    <div class="page-overflow-5" />

    <div class="p-4 w-full">
      <NuxtPage />
    </div>
  </main>
</template>

<i18n>
en:
  preview_alt: Login to get even more features of the site

ru:
  preview_alt: Авторизуйтесь чтобы получить еще больше возможностей сайта

de:
  preview_alt: Melden Sie sich an, um noch mehr Funktionen der Website zu nutzen

es:
  preview_alt: Inicie sesión para obtener aún más funciones del sitio

fr:
  preview_alt: Connectez-vous pour obtenir encore plus de fonctionnalités du site
</i18n>
